import Toast, { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Toast);

    const toast = useToast();
    console.log('Toast Plugin Initialized', toast);
    
    // Display a toast message when the plugin is initialized
    toast.success('Toast Plugin Initialized');
});
